export default __webpack_public_path__ + "static/media/fleetOperators.1bb239ff.png";